import { useState, useEffect } from 'react'
import { Outlet } from 'react-router'
import { Sidebar } from './sidebar'
import { Topbar } from './topbar'
import { ConfigWarning } from '@/components/config-warning'
import { IdentityWarning } from '@/components/identity-warning'
import { TestbedIdentityNotice } from '@/components/testbed-identity-notice'
import { useIdentity } from '@/hooks/useIdentity'
import { isTestbed } from '@/lib/testbed'

export function MainLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    // Check localStorage for saved preference
    const saved = localStorage.getItem('sidebarCollapsed')
    return saved === 'true'
  })
  const { isError, error: identityError } = useIdentity()

  // Save sidebar collapse state to localStorage
  useEffect(() => {
    localStorage.setItem('sidebarCollapsed', String(sidebarCollapsed))
  }, [sidebarCollapsed])

  const handleToggleSidebar = () => {
    setSidebarCollapsed(prev => !prev)
  }

  return (
    <div className="flex h-screen overflow-hidden bg-bg">
      <Sidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        collapsed={sidebarCollapsed}
        onToggleCollapse={handleToggleSidebar}
      />
      <div className="flex flex-1 flex-col overflow-hidden">
        <ConfigWarning />
        {isError &&
          (isTestbed() ? <TestbedIdentityNotice error={identityError} /> : <IdentityWarning />)}
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        {/* `relative` so an absolutely positioned child (the screen-reader-only
            "Showing N of M" status under a long list is one) is placed, and
            clipped, inside this scroll container. Without it such a child is
            positioned against the page, escapes the clip and makes the whole
            document scrollable beside `main`: on the Cleaning list it was 3400px
            tall in a 900px window, and a drag then autoscrolled the wrong
            scroller. */}
        <main className="relative flex-1 overflow-y-auto bg-bg">
          <div className="container mx-auto p-4 md:p-6">
            <Outlet />
          </div>
        </main>
      </div>
      {/* Overlay for mobile sidebar */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/60 backdrop-blur-xs md:hidden transition-opacity duration-300"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  )
}
